import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Icon from 'react-fa';

const IconWithText = ({ valid }) => {
  const icon = valid ?
    { glyph: 'check', class: 'success', text: 'Task is valid' } :
    { glyph: 'times', class: 'danger', text: 'Task is invalid' };

  return (
    <Row className={`text-${icon.class}`}>
      <Icon name={icon.glyph} size='lg' className={icon.class} /> {icon.text}
    </Row>
  );
};

IconWithText.propTypes = {
  valid: PropTypes.bool,
};

const JobTaskFeedback = ({ valid }) => (
  <div>
    <Col md={12}>
      <IconWithText valid={valid} />
    </Col>
  </div>
);

JobTaskFeedback.propTypes = {
  valid: PropTypes.bool,
};

export default JobTaskFeedback;
